import { createServices } from 'services/services';
import { createUserPresenter } from 'stores/user_store';
import { createCommonDatePresenter } from './commonDate_store';
import { createMCCommandPresenter } from './matchCardCommand_store';
import { createProductRoutingPresenter } from './productRouting_store';
import { createProductPresenter } from './product_store';
import { createReportPresenter } from './report_store';
import { createRoutingPresenter } from './routing_store';
import { createTestTargetPresenter } from './testTarget_store';
import { createWorkOrderPresenter } from './workOrder_store';
import { createUiPresenter } from './ui_store';
import { createHistoryReceivesPresenter } from './historyReceive_store';
import { createReportSavedPresenter } from './reportSaved_store';
import { createProductionPlanningPresenter } from './productionPlanning_store';
import { createStyleCategoryPresenter } from './styleCategory_store';

// khỏi tạo services
export const services = createServices();

// khởi tạo ui presenter
export const uiPresenter = createUiPresenter();
export const uiStore = uiPresenter.createStore();

// khởi tạo presenter và store của user
export const userPresenter = createUserPresenter(services);
export const userStore = userPresenter.createStore();

// khởi tạo presenter và store của test target
export const testTargetPresenter = createTestTargetPresenter(services);
export const testTargetStore = testTargetPresenter.createStore();

// khởi tạo presenter và store của routing cong doan
export const routingPresenter = createRoutingPresenter(services);
export const routingStore = routingPresenter.createStore();

// khởi tạo presenter và store của work order
export const workOrderPresenter = createWorkOrderPresenter(services);
export const workOrderStore = workOrderPresenter.createStore();

// khởi tạo presenter và store của product
export const productPresenter = createProductPresenter(services, services);
export const productStore = productPresenter.createStore();

// khởi tạo presenter và store của report
export const reportPresenter = createReportPresenter(services);
export const reportStore = reportPresenter.createStore();

// khởi tạo presenter và store của common Date
export const commonDatePresenter = createCommonDatePresenter(services);
export const commonDateStore = commonDatePresenter.createStore();

// khởi tạo presenter và store của Product Routing
export const productRoutingPresenter = createProductRoutingPresenter(services);
export const productRoutingStore = productRoutingPresenter.createStore();

// khởi tạo presenter và store của match card command
export const mCComandPresenter = createMCCommandPresenter(services);
export const mCComandStore = mCComandPresenter.createStore();

// History Receive (lịch sử nhập kho)
export const historyReceivePresenter = createHistoryReceivesPresenter(services);
export const historyReceiveStore = historyReceivePresenter.createStore();

// Luu mau bao cao
export const reportSavedPresenter = createReportSavedPresenter(services);
export const reportSavedStore = reportSavedPresenter.createStore();

// Báo cáo kế hoạch sản xuất
export const productionPlanningPresenter = createProductionPlanningPresenter(services);
export const productionPlanningStore = productionPlanningPresenter.createStore();


export const styleCategoryPresenter = createStyleCategoryPresenter(services);
export const styleCategoryStore = styleCategoryPresenter.createStore();